import { useNavigate, useParams } from 'react-router-dom';
import AppDataWrapper from '../../../components/containers/AppDataWrapper';
import { Button, Typography } from '@mui/material';
import { TicketsOpModuleContext } from '../context/TicketsOperationContext';
import { useContext, useEffect, useMemo, useState } from 'react';
import useDataClient from '../../../hooks/useDataClient';
import { AppContext, DashboardContext } from '../../../context';
import { ticketsAdapter } from '../../../adapter/tickets.adapter';
import { JiraIssue } from '../../../types';
import Error404 from '../../../components/error/Error404';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AttachmentsTicket from './AttachmentsTicket';
import FormPlainNewComment from './FormPlainNewComment';

export default function DetailTicket() {
    const navigate = useNavigate();
    const appContext = useContext(AppContext);
    const dashboardContext = useContext(DashboardContext);
    const context = useContext(TicketsOpModuleContext);
    const { idTicket } = useParams();
    const checkIssueClient = useDataClient<JiraIssue>({ appContext });
    const issueData = useMemo(() => checkIssueClient.status.data, [checkIssueClient.status]);
    const [newComment, setNewComment] = useState(false);

    function updateTicketInfo() {
        setNewComment(false);
        checkIssueClient.executeRequest();
    }

    useEffect(() => {
        if (idTicket) {
            checkIssueClient.executeRequest(ticketsAdapter.checkIssue(context?.target?.idCredential || 0, idTicket))
        }
    }, [idTicket])

    return (
        <AppDataWrapper
            replaceMenu={dashboardContext?.navBar.menuSelected ? {
                ...dashboardContext?.navBar.menuSelected,
                breadcrumbs: [...dashboardContext?.navBar.menuSelected?.breadcrumbs, { label: idTicket || '', path: '' }]
            } : undefined}
            optionAppend={<Button variant='contained' className='app-btn-color-third' size='small' onClick={() => navigate(`${context?.path}/ticket`)}>
                + Nuevo ticket
            </Button>}>
            {issueData ? <div
                className='ticket-grid-card plain'
                role='button'
                tabIndex={0}
            >
                <div className='ticket-grid-card-header'>
                    <h4><FontAwesomeIcon icon="ticket" /> {issueData.key}</h4>
                    {issueData.created && <Typography sx={{ color: 'text.secondary', textAlign: 'right' }} component={'div'}>
                        <small><FontAwesomeIcon icon="calendar-alt" /> {issueData.created?.slice(0, 16).replace('T', ' ')}</small>
                    </Typography>}
                </div>
                <div className='ticket-grid-card-body'>
                    <Typography component={'div'}>
                        <b>{issueData.summary}</b>
                    </Typography>
                    <br />
                    <Typography component={'div'}>
                        <div dangerouslySetInnerHTML={{ __html: issueData.description }}></div>
                    </Typography>
                    <br />
                    <AttachmentsTicket
                        idCredential={context?.target?.idCredential || 0}
                        attachments={issueData.attachments || []}
                        title={`${issueData.key} - ${issueData.summary}`}
                    />
                    <div className='d-flex'>
                        {issueData.updated && <Typography variant='caption' sx={{ color: 'text.secondary' }} component={'div'}>
                            <small><FontAwesomeIcon icon={'clock'} /> Actualizado: {issueData.updated.slice(0, 10)?.slice(0, 16).replace('T', ' ')}</small>
                        </Typography>}
                        <div className='m-l-auto d-flex' style={{ gap: '0.5rem' }}>
                            <div className='m-auto ticket-circle' style={{ background: issueData.status.color }}></div>
                            <div className='m-auto'>{issueData.status.label}</div>
                        </div>
                    </div>
                </div>
                <div className='comments' style={{ marginTop: '2rem', borderTop: 'none' }}>
                    <div className={`comment-input ${newComment && 'active'}`}>
                        {newComment ? <FormPlainNewComment
                            onUpdate={updateTicketInfo}
                            issueTarget={issueData}
                            onClose={() => setNewComment(false)}
                        /> : <>
                            <div className='comment-input-user'>
                                <FontAwesomeIcon icon='circle-user' style={{ fontSize: '1.5rem' }} />
                            </div>
                            <div className='comment-input-label w-100' onClick={() => setNewComment(true)}>
                                <Typography variant='body1' color={'GrayText'} style={{ margin: '0', borderBottom: '1px solid gray' }}>
                                    Agregar un comentario
                                </Typography>
                            </div>
                        </>}
                    </div>
                    {issueData.comments?.map(comment => <article className='comment' id={String(comment.id)}>
                        <div className='comment-user'>
                            <Typography variant='body2'><FontAwesomeIcon icon='user' className='comment-user-icon' /> <b>{comment.author || 'Usuario'}</b></Typography>
                            <Typography variant='caption'><small>{comment.updated}</small></Typography>
                        </div>
                        <div className='comment-body'>
                            <div className='comment-body-content' dangerouslySetInnerHTML={{ __html: comment.text.join('<br/>') }} />
                        </div>
                        <AttachmentsTicket
                            idCredential={context?.target?.idCredential || 0}
                            attachments={comment.media || []}
                            title={`${issueData.key} - ${issueData.summary}`}
                        />
                    </article>)}
                </div>
            </div> : <Error404 />}
        </AppDataWrapper>
    )
}
